<template>
  <b-modal
    ref="modalLoadingDownload"
    body-class="!p-6 text-black w-full flex flex-col items-center justify-center gap-[12px] text-center"
    size="sm"
    centered
    hide-footer
    hide-header
    hide-header-close
    no-close-on-esc
  >
    <b-spinner
      class="!size-[100px] !border-[#4285F4] !border-l-white !border-[8px] mb-[12px]"
      label="Spinning"
    />
    <p class="mb-0">
      Tunggu beberapa saat, proses refresh order kamu sedang berjalan.
    </p>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalLoadingDownload',
  methods: {
    showModal() {
      this.$refs.modalLoadingDownload.show()
    },
    closeModal() {
      this.$refs.modalLoadingDownload.hide()
    },
  },
}
</script>
